function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, createRef, useEffect } from "react";
import useDetectPrint from "react-detect-print";
import _ from "underscore";
import Utils from "./utils";
import * as Helpers from "./visualisation_helpers";

/**
 * Alignment viewer.
 */
// export default class HSP extends React.Component {
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function HSP(props) {
  var hsp = props.hsp;
  var hspRef = /*#__PURE__*/createRef();
  var printing = useDetectPrint();
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    chars = _useState2[0],
    setChars = _useState2[1];
  var _useState3 = useState(window.innerWidth),
    _useState4 = _slicedToArray(_useState3, 2),
    width = _useState4[0],
    setWidth = _useState4[1];
  var domID = function domID() {
    var query = props.query,
      hit = props.hit,
      hsp = props.hsp;
    return "Query_".concat(query.number, "_hit_").concat(hit.number, "_").concat(hsp.number);
  };
  var hitDOM_ID = function hitDOM_ID() {
    return "Query_" + props.query.number + "_hit_" + props.hit.number;
  };
  useEffect(function () {
    // Attach a debounced listener to handle window resize events 
    // Updates the width state with the current window width, throttled to run at most once every 125ms
    var handleResize = _.debounce(function () {
      return setWidth(window.innerWidth);
    }, 125);
    window.addEventListener("resize", handleResize);

    // TODO: print handler
    draw();
  }, []);
  useEffect(function () {
    draw(printing);
  }, [printing, width]);
  var draw = function draw() {
    var printing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var charWidth = props.getCharacterWidth();
    var containerWidth = printing ? 900 : $(hspRef.current).width();
    setChars(Math.floor((containerWidth - 4) / charWidth));
  };

  /**
   * Returns an array of span elements or plain strings (React automatically
   * adds span tag around strings). This array is passed as it is to JSX to be
   * rendered just above the pairwise alignment (see render method).
   *
   * We cannot return a string from this method otherwise we wouldn't be able
   * to use JSX elements to format text (like, superscript).
   */
  var hspStats = function hspStats() {
    // An array to hold text or span elements that make up the line.
    var line = [];

    // Bit score and total score.
    /*     line.push(
          `Score: ${Utils.inTwoDecimal(hsp.bit_score)} (${hsp.score}), `
        ); */

    // E value
    line.push("E value: ");
    line.push(Utils.inExponential(hsp.evalue));
    line.push(", ");

    // Query coverage
    line.push("Coverage: ".concat(hsp.qcovhsp, "%, "));

    // Identity
    line.push(["Identity: ".concat(Utils.inFraction(hsp.identity, hsp.length), " (").concat(Utils.inPercentage(hsp.identity, hsp.length), "), ")]);

    // Positives (for protein alignment).
    if (props.algorithm === "blastp" || props.algorithm === "blastx" || props.algorithm === "tblastn" || props.algorithm === "tblastx") {
      line.push("Positives: ".concat(Utils.inFraction(hsp.positives, hsp.length), " (").concat(Utils.inPercentage(hsp.positives, hsp.length), "), "));
    }

    // Gaps
    line.push("Gaps: ".concat(Utils.inFraction(hsp.gaps, hsp.length), " (").concat(Utils.inPercentage(hsp.gaps, hsp.length), ")"));
    switch (props.algorithm) {
      case "tblastx":
        line.push(", Frame: ".concat(Utils.inFraction(hsp.qframe, hsp.sframe)));
        break;
      case "blastn":
        line.push(", Strand: ".concat(hsp.qframe > 0 ? "+" : "-", " / ").concat(hsp.sframe > 0 ? "+" : "-"));
        break;
      case "blastx":
        line.push(", Query Frame: ".concat(hsp.qframe));
        break;
      case "tblastn":
        line.push(", Hit Frame: ".concat(hsp.sframe));
        break;
    }
    return line;
  };

  // Width of the coordinate part of hsp lines. Essentially the length of
  // the largest coordinate.
  var hspLinesWidth = function hspLinesWidth() {
    return _.max(_.map([hsp.qstart, hsp.qend, hsp.sstart, hsp.send], function (n) {
      return n.toString().length;
    }));
  };

  /**
   * Returns array of pre tags containing the three query, middle, and subject
   * lines that together comprise one 'rendered line' of HSP.
   */
  var hspLines = function hspLines() {
    // Space reserved for showing coordinates
    var width = hspLinesWidth();

    // Number of residues we can draw per line is the total number of
    // characters we can have in a line minus space required to show left
    // and right coordinates minus 10 characters reserved for displaying
    // the words Query, Subject and three blank spaces per line.
    var adjustedLineWidth = chars - 2 * width - 10;

    // Number of lines of pairwise-alignment (i.e., each line consists of 3
    // lines). We draw as many pre tags.
    var lines = Math.ceil(hsp.length / adjustedLineWidth);
    var pp = [];
    var nqseq = getNqseq();
    var nsseq = getNsseq();
    for (var i = 1; i <= lines; i++) {
      var seq_start_index = adjustedLineWidth * (i - 1);
      var seq_stop_index = seq_start_index + adjustedLineWidth;
      var lqstart = nqseq;
      var lqseq = hsp.qseq.slice(seq_start_index, seq_stop_index);
      var lqend = nqseq + (lqseq.length - lqseq.split("-").length) * qframe_unit() * qframe_sign();
      nqseq = lqend + qframe_unit() * qframe_sign();
      var lmseq = hsp.midline.slice(seq_start_index, seq_stop_index);
      var lsstart = nsseq;
      var lsseq = hsp.sseq.slice(seq_start_index, seq_stop_index);
      var lsend = nsseq + (lsseq.length - lsseq.split("-").length) * sframe_unit() * sframe_sign();
      nsseq = lsend + sframe_unit() * sframe_sign();
      pp.push( /*#__PURE__*/_jsxs("pre", {
        className: "pre-item m-0 p-0 rounded-none border-0 bg-inherit whitespace-pre-wrap break-keep mt-1 tracking-wider",
        children: [/*#__PURE__*/_jsx("span", {
          className: "text-gray-500",
          children: "Query   ".concat(formatCoords(lqstart, width), " ")
        }), /*#__PURE__*/_jsx("span", {
          children: lqseq
        }), /*#__PURE__*/_jsx("span", {
          className: "text-gray-500",
          children: " ".concat(lqend)
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("span", {
          className: "text-gray-500",
          children: "".concat(formatCoords("", width + 8), " ")
        }), /*#__PURE__*/_jsx("span", {
          children: lmseq
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("span", {
          className: "text-gray-500",
          children: "Subject ".concat(formatCoords(lsstart, width), " ")
        }), /*#__PURE__*/_jsx("span", {
          children: lsseq
        }), /*#__PURE__*/_jsx("span", {
          className: "text-gray-500",
          children: " ".concat(lsend)
        }), /*#__PURE__*/_jsx("br", {})]
      }, hsp.number + "," + i));
    }
    return pp;
  };

  // Alignment start coordinate for query sequence.
  //
  // This will be qstart or qend depending on the direction in which the
  // (translated) query sequence aligned.
  var getNqseq = function getNqseq() {
    switch (props.algorithm) {
      case "blastp":
      case "blastx":
      case "tblastn":
      case "tblastx":
        return hsp.qframe >= 0 ? hsp.qstart : hsp.qend;
      case "blastn":
        // BLASTN is a bit weird in that, no matter which direction the query
        // sequence aligned in, qstart is taken as alignment start coordinate
        // for query.
        return hsp.qstart;
    }
  };

  // Alignment start coordinate for subject sequence.
  //
  // This will be sstart or send depending on the direction in which the
  // (translated) subject sequence aligned.
  var getNsseq = function getNsseq() {
    switch (props.algorithm) {
      case "blastp":
      case "blastx":
      case "tblastn":
      case "tblastx":
        return hsp.sframe >= 0 ? hsp.sstart : hsp.send;
      case "blastn":
        // BLASTN is a bit weird in that, no matter which direction the
        // subject sequence aligned in, sstart is taken as alignment
        // start coordinate for subject.
        return hsp.sstart;
    }
  };

  // Jump in query coordinate.
  //
  // Roughly,
  //
  //   qend = qstart + n * qframe_unit
  //
  // This will be 1 or 3 depending on whether the query sequence was
  // translated or not.
  var qframe_unit = function qframe_unit() {
    switch (props.algorithm) {
      case "blastp":
      case "blastn":
      case "tblastn":
        return 1;
      case "blastx":
      // _Translated_ nucleotide query against protein database.
      case "tblastx":
        // _Translated_ nucleotide query against translated
        // nucleotide database.
        return 3;
    }
  };

  // Jump in subject coordinate.
  //
  // Roughly,
  //
  //   send = sstart + n * sframe_unit
  //
  // This will be 1 or 3 depending on whether the subject sequence was
  // translated or not.
  var sframe_unit = function sframe_unit() {
    switch (props.algorithm) {
      case "blastp":
      case "blastx":
      case "blastn":
        return 1;
      case "tblastn":
        // Protein query against _translated_ nucleotide database.
        return 3;
      case "tblastx":
        // Translated nucleotide query against _translated_
        // nucleotide database.
        return 3;
    }
  };

  // If we should add or subtract qframe_unit from qstart to arrive at qend.
  //
  // Roughly,
  //
  //   qend = qstart + (qframe_sign) * n * qframe_unit
  //
  // This will be +1 or -1, depending on the direction in which the
  // (translated) query sequence aligned.
  var qframe_sign = function qframe_sign() {
    return hsp.qframe >= 0 ? 1 : -1;
  };

  // If we should add or subtract sframe_unit from sstart to arrive at send.
  //
  // Roughly,
  //
  //   send = sstart + (sframe_sign) * n * sframe_unit
  //
  // This will be +1 or -1, depending on the direction in which the
  // (translated) subject sequence aligned.
  var sframe_sign = function sframe_sign() {
    return hsp.sframe >= 0 ? 1 : -1;
  };

  /**
   * Pad given coord with ' ' till its length == width. Returns undefined if
   * width is not supplied.
   */
  var formatCoords = function formatCoords(coord, width) {
    if (width) {
      var padding = width - coord.toString().length;
      return Array(padding + 1).join(" ").concat([coord]);
    }
  };
  var spanCoords = function spanCoords(text) {
    return /*#__PURE__*/_jsx("span", {
      className: "text-gray-700",
      children: text
    });
  };
  return /*#__PURE__*/_jsx("div", {
    className: "hsp pt-px pb-5 border-l-2 border-transparent pl-1 -ml-1",
    id: domID(),
    ref: hspRef,
    "data-parent-hit": hitDOM_ID(),
    children: /*#__PURE__*/_jsxs("p", {
      className: "m-0 p-0 rounded-none border-0 bg-inherit whitespace-pre-wrap break-keep text-sm text-neutral-500 font-semibold tracking-wide",
      children: [props.showHSPNumbers && "".concat(Helpers.toLetters(hsp.number), ". "), hspStats().map(function (s, i) {
        return /*#__PURE__*/_jsx("span", {
          children: s
        }, i);
      })]
    })
  });
}

// Redraw if window resized.
// $(window).resize(
//   _.debounce(function () {
//     _.each(HSPComponents, (comp) => {
//       comp.draw();
//     });
//   }, 100)
// );